import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';

@Component({
  selector: 'app-modal-shell',
  template: `
    <div class="modal-overlay" [class.modal-overlay--top]="align === 'top'" (click)="closed.emit()">
      <div class="modal-dialog-new" (click)="$event.stopPropagation()">
        <div class="modal-header-new">
          <h2 class="modal-title-new">{{ title }}</h2>
          <button class="modal-close-new" (click)="closed.emit()">
            <app-icon name="close" [size]="18" [strokeWidth]="2"></app-icon>
          </button>
        </div>
        <div class="modal-body-new">
          <ng-content></ng-content>
        </div>
        <div class="modal-footer-new">
          <ng-content select="[footer]"></ng-content>
        </div>
      </div>
    </div>
  `
})
export class ModalShellComponent {
  @Input() title = '';
  @Input() align: 'center' | 'top' = 'center';
  @Output() closed = new EventEmitter<void>();

  @HostListener('document:keydown.escape')
  onEscape(): void {
    this.closed.emit();
  }
}
